<div *ngIf="repos" class="p-3">
    <h6 class="border-bottom border-gray pb-2 mb-0">Found repositories ({{repos.length}})</h6>
    <div *ngFor="let repo of repos">
        <div class="media text-muted pt-3">
            <p class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
                <strong class="d-block text-gray-dark">{{repo.name}}</strong>
                {{repo.description}}
                <small class="d-block">
                    <a target="_blank" href="{{repo.html_url}}">&rarr; Visit repository</a>
                </small>
            </p>
        </div>
    </div>
</div>
